import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import ProviderManager from '../../../../provider/providerManager';
import imageMapSrc from '../assets/mapIcon.svg';
import Property from '@episerver/spa-core/Components/Property';
import imageLightSrc from '../assets/lightIcon.svg';
import {PageView, ErrorView} from '../Shared/Constants';

const InitStep = ({data, context, changeStep, setCurrentError, guid, setCoords, setGeoError}) => {
  let btnText = data?.mainButtonText?.value ? data?.mainButtonText?.value : 'איתור המיקום שלי';
  const handleSubmit = () => {
    const fetchData = async () => {
      try {
        const result = await ProviderManager.getProviderData('getClientLocationData', [guid]);
        if (!result.Body.isActive) {
          setCurrentError(ErrorView.ValidationGuid);
          changeStep(PageView.Lead);
        } else {
          changeStep(PageView.ShowLocation);
        }
      } catch (e) {
        setCurrentError(89);
        changeStep(PageView.ErrorPopUp);
      }
    };

    const advanceLocation = async () => {
      changeStep(PageView.Loader);

      await fetchData();
    };

    setCoords(null);
    setGeoError(null);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoords({
          lat: position.coords.latitude,
          long: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });
        advanceLocation();
      },
      (error) => {
        setGeoError(error);
        advanceLocation();
      },
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 12000,
      },
    );
  };
  return (
    <>
      <Container>
        <div>
          <Row className='justify-content-center'>
            <Col xs={12} md={12}>
              <strong>
                <Property className='init-step__tittle' context={context} iContent={data} field='mainLocationPageTittle' />
              </strong>
            </Col>
          </Row>
          <Row className='justify-content-center'>
            <Property className='init-step__sub-tittle' context={context} iContent={data} field='mainLocationSubTittle' />
          </Row>
          <Row className='justify-content-center'>
            <Image className='init-step__map-img' src={imageMapSrc} alt='מפה' />
          </Row>
          <Row>
            <Property className='init-step__legal-tittle' context={context} iContent={data} field='mainTitleLegalInformation' />
          </Row>
          <Row className='justify-content-center'>
            <div className='init-step__text'>
              <ul>
                {data?.listMainLegalInformation?.value &&
                  data.listMainLegalInformation.value.map((legalInfo, index) => {
                    return (
                      <li key={index}>
                        <span> &#10010;</span>
                        <span>{legalInfo}</span>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </Row>
          <Row className='justify-content-center'>
            <span className='init-step__divider'></span>
            <div className='init-step__privacy-text'>
              <Image src={imageLightSrc} alt='פעמון' />
              <span>
                <Property context={context} iContent={data} field='mainTextApproveGetLocation' />
              </span>
            </div>
          </Row>
          <Row className='justify-content-center'>
            <div className='init-step__button'>
              <BtnSubmit text={btnText} onclick={() => handleSubmit()} />
            </div>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default InitStep;
